import { useEffect } from "react";
import { useToast } from "@monorepo/ui";
import { useAuth } from "./auth-context";

/**
 * Global Authentication Error Handler
 * 
 * Listens for system-wide "auth:unauthorized" events triggered by the HTTP client
 * when a backend returns a 401 Unauthorized status (e.g., token expired).
 * 
 * Displays a user-friendly toast message informing them of the expiration
 * as the AuthContext automatically redirects them to the beginning of the flow.
 */
export function AuthErrorHandler() {
    const { showToast } = useToast();
    const { logout } = useAuth();

    useEffect(() => {
        const handleUnauthorized = () => {
            // Show toaster notification
            showToast("Your session has expired. Please start over.", "error");

            // Ensure local state is wiped as a fallback (AuthContext also does this)
            logout();
        };

        window.addEventListener("auth:unauthorized", handleUnauthorized);

        return () => {
            window.removeEventListener("auth:unauthorized", handleUnauthorized);
        };
    }, [showToast, logout]);

    // This is a logic-only component that doesn't render any DOM footprint itself
    return null;
}
